import { getCreditReport, refreshCredit, runQuotationCreditSearch } from '../api/checks'
import type { Resolvers } from '../generated/server/resolvers'

const CreditReportResolvers: Resolvers = {
  Query: {
    creditReport: async (_, { useClientApi, clientId, documentId, requests }) => {
      return await getCreditReport(useClientApi, clientId, documentId, requests)
    },
    creditRefreshAvailability: async (_, { clientId }) => {
      return await refreshCredit(clientId, true)
    },
  },
  Mutation: {
    runQuotationCreditSearch: async (_, { clientIds }) => {
      return await runQuotationCreditSearch(clientIds)
    },
    refreshCreditReport: async (_, { clientId }) => {
      return await refreshCredit(clientId, false)
    },
  },
}

export default CreditReportResolvers
